var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarTodayFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 10,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9544 18.0682C12.4772 18.0682 12.0738 17.9034 11.7442 17.5739C11.4147 17.2443 11.2499 16.8409 11.2499 16.3636C11.2499 15.8864 11.4147 15.483 11.7442 15.1534C12.0738 14.8239 12.4772 14.6591 12.9544 14.6591C13.4317 14.6591 13.8351 14.8239 14.1647 15.1534C14.4942 15.483 14.659 15.8864 14.659 16.3636C14.659 16.8409 14.4942 17.2443 14.1647 17.5739C13.8351 17.9034 13.4317 18.0682 12.9544 18.0682ZM10.2272 21.8182C9.85216 21.8182 9.53114 21.6847 9.26409 21.4176C8.99705 21.1506 8.86353 20.8296 8.86353 20.4546V10.9091C8.86353 10.5341 8.99705 10.2131 9.26409 9.94603C9.53114 9.67898 9.85216 9.54546 10.2272 9.54546H10.909V8.86364C10.909 8.67046 10.9743 8.50853 11.105 8.37785C11.2357 8.24716 11.3976 8.18182 11.5908 8.18182C11.784 8.18182 11.9459 8.24716 12.0766 8.37785C12.2073 8.50853 12.2726 8.67046 12.2726 8.86364V9.54546H17.7272V8.86364C17.7272 8.67046 17.7925 8.50853 17.9232 8.37785C18.0539 8.24716 18.2158 8.18182 18.409 8.18182C18.6022 8.18182 18.7641 8.24716 18.8948 8.37785C19.0255 8.50853 19.0908 8.67046 19.0908 8.86364V9.54546H19.7726C20.1476 9.54546 20.4686 9.67898 20.7357 9.94603C21.0027 10.2131 21.1363 10.5341 21.1363 10.9091V20.4546C21.1363 20.8296 21.0027 21.1506 20.7357 21.4176C20.4686 21.6847 20.1476 21.8182 19.7726 21.8182H10.2272ZM10.2272 20.4546H19.7726V13.6364H10.2272V20.4546Z",
    fill: "#4C4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarTodayFill);
export default __webpack_public_path__ + "static/media/calendar_today-fill.b13ae7bf.svg";
export { ForwardRef as ReactComponent };